import script from "./CompanyStatusTag.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyStatusTag.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyStatusTag.vue?vue&type=style&index=0&id=cc430132&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc430132"]])

export default __exports__